export default {
  clickSearch: {
    width: "100%",
    padding: 30,
    display: "block",
    textAlign: "center",
  },
  paper: {
    marginBottom: 4,
    "& header": {
      padding: 0,
    },
  },
  heading: {
    marginBottom: 30,
  },
  controls: {
    padding: 15,
  },
  popupIndicator: {
    backgroundColor: "red",
  },
  banner: {
    marginBottom: 15,
  },
};
